import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/analytics'
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from 'config'
import {Common} from './js/common.js'
import '@/assets/scss/style.scss'
import '@/assets/scss/font.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'


// 本番環境のみエラー内容をアナリティクスに送信
if( !config.isDebug ){
  Vue.config.errorHandler = (err, vm, info) => {
    const message = err?.message || String(err);

    window.gtag('event', 'exception', {
      description: `[Vue2] ${message} | info=${info}`,
      fatal: true,
    });

    window.gtag('event', 'js_error', {
      message: message.slice(0, 200),
      info,
      page_location: location.href,
    });
  };

  // 同期エラー（リソース読み込み含む）
  window.addEventListener('error', (event) => {
    // `event.error` が無いこともある（リソース系）
    const message = event?.error?.message || event?.message || 'Unknown JS error';
    window.gtag('event', 'exception', {
      description: `[window.error] ${message}`,
      fatal: false,
    });
  }, true);

  // 非同期の未処理Promise
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason?.message || String(event?.reason || 'unhandledrejection');
    window.gtag('event', 'exception', {
      description: `[unhandledrejection] ${reason}`,
      fatal: false,
    });
  });
}

Vue.config.devtools = true;
Vue.config.productionTip = false

Vue.directive('visible', function(el, binding) {
	el.style.visibility = !binding.value ? 'visible' : 'hidden';
});

firebase.initializeApp(config.firebaseConfig);
// firebase.analytics();

let blankAxios = axios.create()

const configMixin = Vue.mixin({
  created: function () {
    this.$config = config
    this.$common = Common
    this.$blankAxios = blankAxios
  }
})

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, PUT, OPTIONS';
axios.defaults.baseURL = config.domain;

Vue.use(VueAxios,axios)

new Vue({
  router,
  store,
  configMixin,
  render: h => h(App)
}).$mount('#app')

